import { Fade, HStack } from '@chakra-ui/react'
import { PUBLIC_ROUTES } from '../routes'
import { useLocation } from 'react-router-dom'
import { CustomLink } from 'components'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Sidetab } from '@typeform/embed-react'
import { CONTACT_SUPPORT_FORM_ID } from '../../../../constants'
import { useAuthContext } from '../../../../context/AuthProvider'
import { theme } from 'theme'

type LaptopProps = {}

const Laptop: React.FC<LaptopProps> = ({}) => {
  const location = useLocation()
  const { t } = useTranslation()
  const { isAuthenticated } = useAuthContext()

  return (
    <Fade in={true}>
      <HStack
        spacing={6}
        fontWeight="extrabold"
        ml={16}
        textTransform="uppercase"
        letterSpacing={0.1}
        fontSize={9}
      >
        {PUBLIC_ROUTES(t, isAuthenticated || false).map(({ title, path }) => {
          const active = location.pathname === path

          return <CustomLink key={title + path} path={path} title={title} active={active} />
        })}
        <Sidetab
          id={CONTACT_SUPPORT_FORM_ID}
          buttonColor={theme.colors.blue[100]}
          buttonText="Contact Us"
        />
      </HStack>
    </Fade>
  )
}

export default Laptop
